export const DraggableItemTypes = {
    BeaconItem: "beaconItem"
};
